// extracted by mini-css-extract-plugin
export var completionBody = "_e2-2";
export var completionCard = "_e2-0";
export var completionFooter = "_e2-3";
export var completionTitle = "_e2-1";